import React from 'react';
import ContentLoader from 'react-content-loader';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

const styles = () =>
  createStyles({
    root: {
      width: '100%',
      minWidth: 600,
      display: 'flex',
    },
    nested: {
      width: 600,
      height: 70,
    },
    toRight: {
      marginLeft: 'auto',
    },
  });

export interface ContentLoaderChatMessageProps extends WithStyles<typeof styles> {
  toRight: boolean;
}

const ContentLoaderChatMessage: React.FC<ContentLoaderChatMessageProps> = ({ classes, toRight, ...rest }) => (
  <div className={classes.root}>
    <div className={classnames(classes.nested, { [classes.toRight]: toRight })}>
      <ContentLoader rtl={toRight} height={70} width={550}>
        <circle cx="31" cy="31" r="15" />
        <rect x="58" y="18" rx="5" ry="5" width="300" height="10" />
        <rect x="58" y="34" rx="5" ry="5" width="300" height="10" />
      </ContentLoader>
    </div>
  </div>
);

export default withStyles(styles)(ContentLoaderChatMessage);
